define([
    'data/config',
    'data/routes'
],
function(
    config, routes
){

    var getRouteFromUrl = function(url){

        if(url.indexOf(':/') <= 0) {
            if(url.substr(0,1) === '/') url = url.substr(1);
            return getRouteFromString(url);
        }
        else {
            return getRouteFromString(url.substr(config.baseUrl.length));
        }
    }

    var getRouteFromString = function(string){

        if(routes[string]) {
            return routes[string]
        }
        else {
            for(var k in routes) {
                if(new RegExp(k).test(string) === true) {
                    return routes[k];
                }
            }
        }

        return false;
    }

    return {
        getRouteFromUrl: getRouteFromUrl,
        getRouteFromString: getRouteFromString
    }

})